import { TextV2 } from '@dealstack/frontend/shared/components/TextV2/TextV2';
import styled from 'styled-components';

export const DistributionTableSupportText = styled(TextV2)`
	color: ${({ theme }) => theme.v3.colors.dark[0]};
`;
